export default {
    "clipboard": {
        "success": "{data} in die Zwischenablage kopiert",
        "error": "Zwischenablagefehler"
    }
};
